import { Listbox } from "@headlessui/react"
import { Fragment, useState } from "react"
import DropDownIcon from "../../../../../../components/svg/DropDownIcon"

export default function SimulateMeta({
  selectedQuestionLocation,
  selectedAdmissionTest,
  setSelectedAdmissionTest,
  admissionTests,
  years,
  selectedYear,
  setSelectedYear,
  paperType,
  selectedPaperType,
  setSelectedPaperType,
  examSectionNumber,
  selectedExamSectionNumber,
  setSelectedExamSectionNumber,
  getExamSectionNumber,
  onBlur,
  selectedSubject,
  setSelectedSubject,
  getTopicsBySubjectId,
  subjects
}) {
  const [inputValue, setInputValue] = useState("")
  const [inputValuePaperQuestions, setInputValuePaperQuestions] = useState("")
  const [inputValueMockPaper, setInputValueMockPaper] = useState("")
  return (
    <>
      {selectedQuestionLocation.name === "Simulate" && (
        <>
          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Admission Test
              </label>
            </div>
            <Listbox
              as="div"
              className="relative w-full"
              value={selectedAdmissionTest}
              onChange={setSelectedAdmissionTest}
              name="questionLocation"
              id="questionLocation"
              onBlur={() => {
                onBlur({
                  admissionTestId: selectedAdmissionTest.id
                })
              }}
            >
              {({ open }) => (
                <>
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-primary ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedAdmissionTest.name
                            ? selectedAdmissionTest.name.length > 23
                              ? selectedAdmissionTest.name.slice(0, 23) + " ..."
                              : selectedAdmissionTest.name
                            : "Select Admission Test"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {admissionTests?.data?.data &&
                      admissionTests.data.data.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Type of paper
              </label>
            </div>
            <Listbox
              as="div"
              className={`relative w-full ${
                !selectedAdmissionTest.id
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              }`}
              value={selectedPaperType}
              onChange={setSelectedPaperType}
              name="questionLocation"
              id="questionLocation"
              disabled={!selectedAdmissionTest.id}
              onBlur={() => {
                onBlur({
                  paperTypeId: selectedPaperType.id
                })
              }}
            >
              {({ open }) => (
                <>
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-primary ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }
                      ${
                        !selectedAdmissionTest.id
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedPaperType.name
                            ? selectedPaperType.name
                            : "Select Type of paper"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {paperType.map(location => (
                      <Listbox.Option
                        key={location.id}
                        value={location}
                        className="flex w-full justify-start"
                      >
                        {location.name}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          {selectedPaperType.id &&
            (selectedPaperType.id === 1 ? (
              <div className="flex flex-col items-start gap-1">
                <div className="flex w-full items-center justify-between px-3">
                  <label
                    htmlFor="questionStyle"
                    className="text-base text-neutral-12"
                  >
                    Year
                  </label>
                </div>
                <Listbox
                  as="div"
                  className="relative w-full"
                  value={selectedYear}
                  onChange={setSelectedYear}
                  name="questionLocation"
                  id="questionLocation"
                  onBlur={() => {
                    onBlur({
                      year: selectedYear
                    })
                    getExamSectionNumber(
                      selectedAdmissionTest.id,
                      selectedPaperType.id,
                      selectedYear
                    )
                  }}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Button as={Fragment}>
                        <button
                          id="admissionTest"
                          className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-primary ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                        >
                          <div className="flex w-full items-center justify-between">
                            <span>
                              {selectedYear ? selectedYear : "Select Year"}
                            </span>
                            <DropDownIcon rotate={`${open ? 180 : 0}`} />
                          </div>
                        </button>
                      </Listbox.Button>
                      <Listbox.Options
                        as="ul"
                        className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                      >
                        {years.map((year, index) => (
                          <Listbox.Option
                            key={index}
                            value={year}
                            className="flex w-full cursor-pointer justify-start"
                          >
                            {year}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </>
                  )}
                </Listbox>
              </div>
            ) : (
              <div className="flex flex-col items-start gap-1">
                <label htmlFor="mockPaperNumber">Mock Paper Number</label>

                <input
                  min={1}
                  max={1000}
                  type="number"
                  name="mockPaperNumber"
                  id="mockPaperNumber"
                  className="w-full rounded-lg border border-neutral-2 px-4 py-2 focus:outline-primary"
                  value={inputValueMockPaper}
                  onChange={e => setInputValueMockPaper(e.target.value)}
                  onBlur={() => {
                    onBlur({
                      mockPaperNumber: inputValueMockPaper
                    })
                    getExamSectionNumber(
                      selectedAdmissionTest.id,
                      selectedPaperType.id,
                      null,
                      inputValueMockPaper
                    )
                  }}
                />
              </div>
            ))}

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Subject
              </label>
            </div>
            <Listbox
              as="div"
              className="relative w-full"
              value={selectedSubject}
              onChange={value => {
                setSelectedSubject(value)
                getTopicsBySubjectId(value.id)
              }}
              name="selectedSubject"
              id="selectedSubject"
              onBlur={() => {
                onBlur({
                  subjectId: selectedSubject.id
                })
              }}
            >
              {({ open }) => (
                <>
                  {/* Render a `Fragment` instead of a `button` */}
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedSubject.name
                            ? selectedSubject.name
                            : "Select Subject Name"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {subjects?.data?.data &&
                      subjects.data.data.subjects.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <label htmlFor="paperLink">Paper Questions</label>

            <input
              min={1}
              max={1000}
              type="number"
              name="paperQuestions"
              id="paperQuestions"
              className="w-full rounded-lg border border-neutral-2 px-4 py-2 focus:outline-primary"
              value={inputValuePaperQuestions}
              onChange={e => setInputValuePaperQuestions(e.target.value)}
              onBlur={() => {
                onBlur({
                  paperQuestions: inputValuePaperQuestions
                })
              }}
            />
          </div>

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3 ">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Exam - Section Number
              </label>
            </div>

            <Listbox
              as="div"
              className="relative w-full"
              value={selectedExamSectionNumber}
              onChange={setSelectedExamSectionNumber}
              name="sectionNumber"
              id="sectionNumber"
              disabled={!selectedYear && !inputValueMockPaper}
              onBlur={() => {
                onBlur({
                  examSectionNumberId: selectedExamSectionNumber.id
                })
              }}
            >
              {({ open }) => (
                <>
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-primary ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }
                        ${
                          !selectedYear && !inputValueMockPaper
                            ? "cursor-not-allowed"
                            : ""
                        }
                      `}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedExamSectionNumber.sectionNumber
                            ? selectedExamSectionNumber.sectionNumber
                            : "Select Section Number"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {examSectionNumber.map(sectionNumber => (
                      <Listbox.Option
                        key={sectionNumber.id}
                        value={sectionNumber}
                        className="flex w-full cursor-pointer justify-start"
                      >
                        {sectionNumber.sectionNumber}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <label htmlFor="paperLink" className="text-base text-neutral-12">
              Paper Link
            </label>

            <input
              type="url"
              name="paperLink"
              id="paperLink"
              className="w-full rounded-lg border border-neutral-2 px-4 py-2 focus:outline-neutral-2"
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              onBlur={() => {
                onBlur({
                  paperLink: inputValue
                })
              }}
            />
          </div>
        </>
      )}
    </>
  )
}
